import React from 'react'
import injectStyles from 'react-jss'

const styles = {
  spacer: {
    borderBottom: '1px solid white',
    height: 1,
    width: '100%',
  },
}

const Spacer = ({ classes }) => <div className={classes.spacer} />

export default injectStyles(styles)(Spacer)



// WEBPACK FOOTER //
// ./src/Components/DashboardSidebar/Spacer.js